import { useEffect, useState } from 'react';

export const useViewport = (): { widthViewport: number } => {
  const [widthViewport, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleWindowResize = () => {
      setWidth(window.innerWidth);
    }

    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

  return { widthViewport };
}
